<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Accessories</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (replacementFilterSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Replacement Filter:</label>
              <select class="halfWidthInputField" #replacementFilterInput
                [class.invalidConfigurationSelection]="isInvalidSelection(replacementFilterSelection.Name)"
                (change)="selectionChanged(replacementFilterSelection, replacementFilterInput.value)"
                [value]="replacementFilterSelection.Value.toString()">
                @for (allowable of replacementFilterSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="replacementFilterSelection.Value && replacementFilterSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (stackKitsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Vertical Stack Kits:</label>
              <select class="halfWidthInputField" #verticalStackKitsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(stackKitsSelection.Name)"
                (change)="selectionChanged(stackKitsSelection, verticalStackKitsInput.value)"
                [value]="stackKitsSelection.Value.toString()">
                @for (allowable of stackKitsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="stackKitsSelection.Value && stackKitsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (stackAccessoriesSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Vertical Stack Accessories:</label>
              <select class="halfWidthInputField" #stackAccessoriesInput
                [class.invalidConfigurationSelection]="isInvalidSelection(stackAccessoriesSelection.Name)"
                (change)="selectionChanged(stackAccessoriesSelection, stackAccessoriesInput.value)"
                [value]="stackAccessoriesSelection.Value.toString()">
                @for (allowable of stackAccessoriesSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="stackAccessoriesSelection.Value && stackAccessoriesSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (hoseKitsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Hose Kits:</label>
              <select class="halfWidthInputField" #hoseKitsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(hoseKitsSelection.Name)"
                (change)="selectionChanged(hoseKitsSelection, hoseKitsInput.value)"
                [value]="hoseKitsSelection.Value.toString()">
                @for (allowable of hoseKitsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="hoseKitsSelection.Value && hoseKitsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (hoseKitAdapterSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Hose Kit Adapter:</label>
              <select class="halfWidthInputField" #hoseKitAdapterInput
                [class.invalidConfigurationSelection]="isInvalidSelection(hoseKitAdapterSelection.Name)"
                (change)="selectionChanged(hoseKitAdapterSelection, hoseKitAdapterInput.value)"
                [value]="hoseKitAdapterSelection.Value.toString()">
                @for (allowable of hoseKitAdapterSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="hoseKitAdapterSelection.Value && hoseKitAdapterSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
